export const PAGINATION_HEADER_CONTINUATION_TOKEN = "x-continuation-token";
//# sourceMappingURL=paginated-result.js.map